import React, { useEffect, useState } from "react";
import Section from "../../components/Section";
import { pageTitle } from "../../helpers/PageTitle";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import axiosInstance from "../../utils/axiosInstance";
import { addAppointmentSlots, addHoliday, deleteAppointmentSlot, deleteHoliday, fetchDoctorProfile, fetchDoctorWalletStatement } from "../../constants/ApiConstants";
import { Link, useNavigate } from "react-router-dom";
import CommonMobileHeader from "../../components/Header/CommonMobileHeader";
import FullPageLoader from "../../components/FullPageLoader";

import toast from "react-hot-toast";
import { linearTopGradient } from "../../constants/colors";
import LoadMore from "../../components/LoadMore";
import { IoAddCircle, IoRemoveCircle } from "react-icons/io5";
import ListEmptyText from "../../components/ListEmptyText";
import MyModal from "../../components/MyModal";
import InputField from "../../components/InputField";
import Button from "../../components/Button";
import SecondaryButton from "../../components/SecondaryButton";

export default function DoctorWallet() {
  pageTitle("Wallet");

  const [loading, setLoading] = useState(false);
  const doctorId = useSelector((state) => state.appSlice.doctorData?.id);
  const settings = useSelector((state) => state.appSlice.settings);
  const [modalData, setModalData] = useState(null);
  const [doctorDetail, setDoctorDetail] = useState(null);
  const [statements, setStatements] = useState([]);
  const [start, setStart] = useState(0);
  const [showLoadMore, setShowLoadMore] = useState(true);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    fetchDoctorDetail();
    fetchWalletStatementListFromServer();
  }, []);

  const fetchDoctorDetail = () => {
    setLoading(true);
    axiosInstance
      .post(fetchDoctorProfile, {
        doctor_id: doctorId,
      })
      .then((res) => {
        setDoctorDetail(res.data.data);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const fetchWalletStatementListFromServer = () => {
    axiosInstance
      .post(fetchDoctorWalletStatement, {
        doctor_id: doctorId,
        start: start,
        count: 10,
      })
      .then((res) => {
        if (start == 0) {
          setStatements(res.data.data);
        } else {
          setStatements((prev) => [...prev, res.data.data]);
        }
        setStart(res.data.data.length + start);
        if (res.data.data.length < 10) {
          setShowLoadMore(false);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  function formatDateTime(input) {
    const date = new Date(input);
    const options = {
      weekday: "short",
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    };
    const formattedDate = date.toLocaleString("en-US", options).replace(",", "");
    const [weekday, day, month, year, time] = formattedDate.split(" ");
    return `${weekday}, ${day} ${month}, ${year} : ${time}`;
  }

  return (
    <Wrapper>
      {loading ? (
        <FullPageLoader />
      ) : (
        <Section topMd={0} topLg={0} topXl={110} bottomMd={200} bottomLg={150} bottomXl={110}>
          <div className="content-wrapper d-flex flex-column px-3 gap-1 justify-content-center mx-auto">
            <CommonMobileHeader canBack title="Wallet" />
            <div className="row">
              <div className="col-md-6">
                <div className="py-3 bg-white">
                  <div className="d-flex justify-content-between align-items-center px-2 py-4 shadow-lg" style={{ background: linearTopGradient, borderRadius: "16px" }}>
                    <strong className="text-light px-3 fw-regular" style={{ fontSize: 24 }}>{`${settings.currency} ${doctorDetail?.wallet || 0.0}`}</strong>
                    <button className="px-3 py-2 rounded" style={{ backgroundColor: "rgb(255,255,255,0.2)", borderRadius: "16px", marginRight: 12 }}>
                      <span className="text-light">Withdraw</span>
                    </button>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <p className="fs-normal text-black">Statement</p>
                {statements.length === 0 && <ListEmptyText text={"No Statements Available."} />}
                {statements.map((statement) => (
                  <div key={statement.id} className={`px-2 py-2 d-flex gap-2 fs-normal align-items-center text-black statementItem ${statement.type == 1 ? "bg-danger-surface" : "bg-success-surface"}`}>
                    {statement.type == 1 ? <IoRemoveCircle color="red" size={24} /> : <IoAddCircle color="green" size={24} />}
                    <div className="d-flex flex-column gap-1">
                      <div className="d-flex gap-1 justify-content-start">
                        {statement.transaction_id?.slice(0, 16)}..<span className={`${statement.type == 0 ? "text-success" : "text-danger"} fs-sm `}>{statement.type == 1 ? "COMMISSION" : "EARNING"}</span>
                      </div>
                      <span className="text-muted fs-sm">{formatDateTime(statement.created_at)}</span>
                    </div>
                    <div className="ml-auto text-muted fw-bold">
                      <span>{`${settings.currency}${statement.amount}`}</span>
                    </div>
                  </div>
                ))}
                {<LoadMore visible={showLoadMore} loading={loading} onLoadMoreClick={fetchWalletStatementListFromServer} />}
              </div>
            </div>
          </div>
        </Section>
      )}
    </Wrapper>
  );
}

const Wrapper = styled.div``;
